const fallbackPasteTextFromClipboard = () => {
  const textAreaElement = document.createElement('textarea');

  textAreaElement.setAttribute('readonly', '');
  textAreaElement.style.left = '0';
  textAreaElement.style.top = '0';
  textAreaElement.style.position = 'fixed';
  textAreaElement.style.opacity = '0';
  textAreaElement.style.width = '1px';
  textAreaElement.style.height = '0';

  document.body.appendChild(textAreaElement);
  textAreaElement.focus();
  textAreaElement.select();

  try {
    document.execCommand('paste');
    const result = textAreaElement.value;
    document.body.removeChild(textAreaElement);
    return result;
  } catch (err) {
    console.error('Fallback: Oops, unable to paste', err);
    document.body.removeChild(textAreaElement);
  }

  return '';
};

export const pasteTextFromClipboard = () => {
  if (!navigator.clipboard) {
    const result = fallbackPasteTextFromClipboard();
    return new Promise<string>(resolve => {
      resolve(result);
    });
  } else {
    return navigator.clipboard.readText();
  }
};

export default pasteTextFromClipboard;
